import React, { useCallback } from 'react';
import css from './styles.module.scss';
import { Chip } from '@material-ui/core';
import DoneIcon from '@material-ui/icons/Done';
import classNames from 'classnames';

interface TilesFilterProps {
    chips: string[];
    filters: string[];
    onFilterChange: (newFilters: string[]) => void;
    className?: string;
}

export const ChipsFilter: React.FC<TilesFilterProps> = ({ chips, filters, onFilterChange, className }) => {
    const handleFilterChose = useCallback(
        (role: string) => {
            onFilterChange([...filters, role]);
        },
        [onFilterChange, filters]
    );

    const handleFilterRemove = useCallback(
        (role: string) => {
            const newRolesFilter = [...filters];
            const removeIndex = newRolesFilter.indexOf(role);
            newRolesFilter.splice(removeIndex, 1);
            onFilterChange(newRolesFilter);
        },
        [filters, onFilterChange]
    );

    return (
        <div className={css.module}>
            {chips.map(title => (
                <Chip
                    className={classNames(css.filterChip, className)}
                    key={title}
                    label={title}
                    clickable
                    color="primary"
                    onClick={!filters.includes(title) ? () => handleFilterChose(title) : () => handleFilterRemove(title)}
                    onDelete={filters.includes(title) ? () => handleFilterRemove(title) : undefined}
                    deleteIcon={filters.includes(title) ? <DoneIcon color="inherit" /> : undefined}
                    variant="outlined"
                />
            ))}
        </div>
    );
};
